import { IComboBox, IComboBoxOption, ComboBox } from '@fluentui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collaborator } from '../../../system/collaborators/Collaborator';

interface IComboBoxInput {
  label: string;
  projectTeamCollaboratorIds: string[]
  colaboratorOptions: Collaborator[];
  colaboratorOptionsFiltered: Collaborator[];
  setColaboratorOptionsFiltered: React.Dispatch<React.SetStateAction<Collaborator[]>>;
  onSelect: (key: string) => void;
}

export const ComboBoxInput = (props: IComboBoxInput) => {
  const { t } = useTranslation();
  const [textDropDown, setTextDropdown] = useState<string>('');
  // const [menuClosed, setMenuClosed] = React.useState(true);

  const onInputValueChange = (value: string) => {
    setTextDropdown(value);
    if (value.length === 0) {
     // Se filtran los que ya esten selecionado
      props.setColaboratorOptionsFiltered(props.colaboratorOptions.filter((option) => !props.projectTeamCollaboratorIds.includes(option.getId())))
      return 
    }
    props.setColaboratorOptionsFiltered(props.colaboratorOptionsFiltered.filter((op) => op.fullName().toLocaleLowerCase().includes(value.toLocaleLowerCase())));
  };

  const onChangeCustomInput = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, index?: number, value?: string) => {
    if (option) {
      props.onSelect(option.key.toString());
      onInputValueChange('');
    }
  };

  return (
    <>
      <ComboBox
        selectedKey={null}
        label={t(props.label)}
        text={textDropDown}
        autoComplete="off"
        // onMenuDismissed={() => setMenuClosed(true)}
        // onMenuOpen={() => setMenuClosed(false)}
        allowFreeform
        openOnKeyboardFocus={true}
        options={props.colaboratorOptionsFiltered.map((c) => ({ text: c.fullName(), key: c.getId() }))}
        onInputValueChange={onInputValueChange}
        onChange={onChangeCustomInput}
      />
      {/* <h5>{menuClosed ? 'presione enter o la flechita para abrir las opciones' : ''}</h5> */}
    </>
  );
};

export default ComboBoxInput;
